const f = <T>(key: string, item: T): void => {
    window.localStorage.setItem(key, typeof item === 'string' ? item : JSON.stringify(item));
};

export default f;
